const dashboardSearchTabs = {
    MEMBER: 'MEMBER',
    CASE: 'CASE',
};

export default dashboardSearchTabs;
